/* ==========================================================================
   SEARCH.JS — Predictive search drawer
   ========================================================================== */
(function () {
  'use strict';

  var input = document.querySelector('[data-search-input]');
  var resultsWrap = document.querySelector('[data-search-results]');
  if (!input || !resultsWrap) return;

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};
  var debounceTimer;
  var lastQuery = '';
  var abortController;

  function moneyFormat(cents) {
    return window.theme.formatMoney(cents);
  }

  function renderHint() {
    resultsWrap.innerHTML = '<p class="search-drawer__hint">' + (strings.searchHint || 'Start typing to search our store') + '</p>';
  }

  function renderNoResults(query) {
    resultsWrap.innerHTML = '<p class="search-drawer__hint">' + (strings.searchNoResults || 'No results found').replace('{{ terms }}', query) + '</p>';
  }

  function renderResults(data, query) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var pages = (data.resources && data.resources.results && data.resources.results.pages) || [];
    var articles = (data.resources && data.resources.results && data.resources.results.articles) || [];

    if (!products.length && !pages.length && !articles.length) {
      renderNoResults(query);
      return;
    }

    var html = '';

    if (products.length) {
      html += '<div class="search-drawer__group"><h3 class="visually-hidden">Products</h3>';
      products.forEach(function (product) {
        var image = product.featured_image ? product.featured_image.url : '';
        /* The predictive search API returns the price in currency units ("69.90"), not cents. */
        var cents = Math.round(parseFloat(product.price) * 100) || 0;
        var price = cents > 0 ? moneyFormat(cents) : (strings.comingSoon || '');
        html +=
          '<a class="search-result" href="' + product.url + '">' +
            '<span class="search-result__media">' + (image ? '<img src="' + image + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="search-result__info">' +
              '<span class="search-result__title" translate="no">' + product.title + '</span>' +
              '<span class="search-result__price">' + price + '</span>' +
            '</span>' +
          '</a>';
      });
      html += '</div>';
    }

    if (pages.length || articles.length) {
      html += '<div class="search-drawer__group"><h3 class="visually-hidden">Pages</h3>';
      pages.concat(articles).forEach(function (item) {
        html +=
          '<a class="search-result" href="' + item.url + '">' +
            '<span class="search-result__info">' +
              '<span class="search-result__title">' + item.title + '</span>' +
            '</span>' +
          '</a>';
      });
      html += '</div>';
    }

    html += '<a class="search-drawer__view-all btn btn--text" href="' + routes.search_url + '?q=' + encodeURIComponent(query) + '">View all results</a>';

    resultsWrap.innerHTML = html;
  }

  function search(query) {
    if (!routes.predictive_search_url) return;
    if (abortController) abortController.abort();
    abortController = new AbortController();

    var url = routes.predictive_search_url + '.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,page,article&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url, { signal: abortController.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderResults(data, query); })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          resultsWrap.innerHTML = '<p class="search-drawer__hint">' + (strings.cartError || 'Something went wrong.') + '</p>';
        }
      });
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();
    window.clearTimeout(debounceTimer);

    if (query === '') {
      renderHint();
      lastQuery = '';
      return;
    }
    if (query === lastQuery) return;
    lastQuery = query;

    debounceTimer = window.setTimeout(function () { search(query); }, 300);
  });

  document.addEventListener('theme:drawer:open', function (e) {
    if (e.detail && e.detail.name === 'search' && input.value.trim() === '') {
      renderHint();
    }
  });
})();
